const AgentListingsPageStyles = {
    container: {
        padding: '2rem',
        maxWidth: '1200px',
        margin: '0 auto',

    },
    title: {
        marginBottom: '1rem',
        textAlign: 'center',
    },
    card: { 
        maxWidth: 345,
    },
    editButton: {
        marginTop: '0.5rem',
        marginRight: '0.5rem',
    },
    deleteButton: {
        marginTop: '0.5rem',
    },
};


export default AgentListingsPageStyles;